import React, { PropsWithChildren } from 'react'
import { createPortal } from 'react-dom'
import { useQuerySelector } from '~/utils'

type QuerySelectorOptions = Parameters<typeof useQuerySelector>[1]
interface Props extends QuerySelectorOptions, PropsWithChildren {
	selector: string
	render?: (el: HTMLElement) => React.ReactNode
}

function isNodeList<T extends HTMLElement>(elem: T | NodeListOf<T> | null): elem is NodeListOf<T> {
	return (elem as NodeList | null)?.length !== undefined
}

/**
 * Like React's built-in {@link createPortal}, except that it watches for possible dom updates made outside React
 * @param props
 * @returns
 */
export const DynamicPortal: React.FC<Props> = ({ selector, multiple = false, render, children }) => {
	const elem = useQuerySelector(selector, { multiple })
	if (isNodeList(elem))
		return <>{Array.from(elem.values()).map(e => createPortal(render ? render(e) : children, e))}</>
	else if (elem) return createPortal(render ? render(elem) : children, elem)
	else return null
}
